<template>
  <div class="main-layout">
    <header-layout></header-layout>
    <div>
      <div class="invoice k-subtitle-md" v-if="showSettleRequestDown">
        <div>{{ $t('common.announcement.settleRequestDownContent') }}</div>
        <div class="close-icon" @click="onCloseSettleRequestDown">
          <KkIcon name="ic_cross_line_lg" />
        </div>
      </div>
      <div class="invoice k-subtitle-md" v-else-if="tipVisible">
        <div v-html="invoiceContent"></div>
        <div class="close-icon" @click="tipVisible = false">
          <KkIcon name="ic_cross_line_lg" />
        </div>
      </div>
      <div class="invoice k-subtitle-md" v-else-if="Object.keys(userInfo)?.length > 0 && memberSignInfo && signTipVisible">
        <div v-html="signTipContent"></div>
        <div class="close-icon" @click="signTipVisible = false">
          <KkIcon name="ic_cross_line_lg" />
        </div>
      </div>
      <div class="invoice k-subtitle-md" v-else-if="Object.keys(userInfo)?.length > 0 && memberSignInfo && laborFuncVisible">
        <div v-html="$t('common.announcement.laborFuncContent')"></div>
        <div class="close-icon" @click="onCloseLaborFunc()">
          <KkIcon name="ic_cross_line_lg" />
        </div>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import headerLayout from './headerLayout.vue'

export default {
  components: {
    headerLayout
  },
  computed: {
    userInfo() {
      return this.$store.state?.account?.userInfo
    },
    memberSignInfo() {
      return this.$store.state?.account?.memberSignInfo
    },
    invoiceContent() {
      const checkAccountFinished = this.userInfo?.affiliate?.member?.check_account_finished
      const checkBankFinished = this.userInfo?.affiliate?.member?.check_bank_finished

      return `${this.$i18n.t('common.announcement.invoice.content',
        {
          profile: (!checkAccountFinished)
            ? `<a href="/affiliate/my-kkpartners?tab=2">${this.$i18n.t('common.announcement.invoice.profile')}</a>`
            : '',
          mark1: ((!checkAccountFinished && checkBankFinished) || (checkAccountFinished && !checkBankFinished))
            ? '' : `${this.$i18n.t('common.announcement.invoice.mark1')}`,
          payment: (!checkBankFinished)
            ? `<a href="/affiliate/my-kkpartners?tab=3">${this.$i18n.t('common.announcement.invoice.payment')}</a>`
            : ''
        })}`
    },
    showSettleRequestDown() {
      const nowDate = new Date()
      if (nowDate < new Date('2025-01-01') || nowDate > new Date('2025-01-15')) {
        return false
      }
      if (localStorage.getItem('knowSettleRequestDown')) {
        return false
      } else {
        return this.settleRequestDownVisible
      }
    }
  },
  data() {
    return {
      tipVisible: false,
      signTipVisible: false,
      laborFuncVisible: false,
      settleRequestDownVisible: true,
      signTipContent: this.$i18n.t('common.announcement.signLaborTip')
    }
  },
  watch: {
    userInfo: {
      handler(info) {
        this.tipVisible = false
        this.laborFuncVisible = false
        this.$store.dispatch('checkSign')
        if (!info?.affiliate?.member) {
          return false
        }
        if (!info?.affiliate?.member?.check_account_finished || !info?.affiliate?.member?.check_bank_finished) {
          this.tipVisible = true
        } else if (info?.affiliate?.member?.bank_country_cd === 'TW' && info?.affiliate?.member?.bank_currency === 'TWD' && info?.affiliate?.member?.profile_type === 1) {
          // 台湾个人户 提示劳报单功能上线
          if (new Date() <= new Date('2024-12-31 23:59:59') && !localStorage.getItem('knowLaborFunc')) {
            this.laborFuncVisible = true
          }
        }
         
      },
      deep: true
    },
    memberSignInfo: {
      handler(info) {
        this.signTipVisible = false
        if (info?.has_cid_need_sign_labor && info?.cid_list?.length > 0) {
          // 有劳报单需要签署提示
          for (const item of this.memberSignInfo.cid_list || []) {
            if (item.is_need_sign && item.commission_amount_check && item.total_settle_price >= 100) {
              this.signTipVisible = true
              localStorage.setItem('knowLaborFunc', true)
              break
            }
          }
        }
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch('getMarketRegions')
    this.$store.dispatch('getIsoCountries')
  },
  methods: {
    onCloseLaborFunc() {
      // 关闭劳报功能提示
      localStorage.setItem('knowLaborFunc', true)
      this.laborFuncVisible = false
    },
    onCloseSettleRequestDown() {
      // 关闭佣金金额由 200USD 降到 100USD 的提示
      localStorage.setItem('knowSettleRequestDown', true)
      this.settleRequestDownVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.main-layout {
  margin-top: 70px;
  margin-bottom: var(--kk-spacing-10);
  min-height: calc(100vh - 70px - var(--kk-spacing-10) - 67px);
  .invoice {
    padding: var(--kk-spacing-5) var(--kk-spacing-10);
    padding-right: calc(var(--kk-spacing-10) + var(--kk-spacing-7) + 16px);
    box-sizing: border-box;
    background: var(--kk-color-background-critical-lighter);
    color: var(--kk-color-background-critical-dark);
    position: relative;
    .close-icon {
      cursor: pointer;
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      right: var(--kk-spacing-10);
      color: var(--kk-color-text-critical-dark);
    }
  }
}
</style>

